'use client'

import Link from 'next/link'
import { HeaderBack } from 'shared/common/Header/ui/HeaderBack/Mobile'
import HeaderBurger from 'shared/common/Header/ui/HeaderBurger/Mobile'
import { HeaderClose } from 'shared/common/Header/ui/HeaderClose/Mobile'
import { Icon } from 'shared/iconpack'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'
import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './FakeHeader.module.scss'

interface FakeHeaderProps {
  backNavigation?: () => void
}
export function FakeHeader({ backNavigation }: FakeHeaderProps) {
  return (
    <header className={styles.header}>
      {backNavigation ? (
        <HeaderBack backNavigation={backNavigation} />
      ) : (
        <HeaderBurger />
      )}
      <div className={styles.search}>
        <Link className={styles.link} href={ROUTER_PATHS.search.get('')} />

        <Icon
          name="magnifier"
          size={20}
          color={globalStyles['--icon-secondary']}
        />
        <span>Найти товары</span>
      </div>
      <HeaderClose />
    </header>
  )
}
